<template>
    <div class="rkld">
        <div class="rkldRight">
            <div class="rkldRightContent">
                <!-- tabs导航 -->
                <el-tabs v-model="editableTabsValue" type="card">
                    <el-tab-pane label="首页" name="1">
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-card class="box-card breakfastreserve">
                                    <div slot="header" class="clearfix">
                                        <span class="clearfix">
                                            <a class="imgbox">
                                                <img
                                                    src="@/assets/foodicon/a1.png"
                                                    alt=""
                                                />
                                            </a>
                                            今日预定</span
                                        >
                                    </div>
                                    <div class="text item bktable">
                                        <el-table
                                            :data="breakfastlist"
                                            style="
                                                width: 100%;
                                                background-color: #eefefa;
                                            "
                                            height="37vh"
                                        >
                                            <el-table-column
                                                type="index"
                                                label="序号"
                                                width="50"
                                                align="center"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                prop="customerName"
                                                label="姓名"
                                                width="70"
                                                align="center"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                prop="takeWay"
                                                label="取餐方式"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            0
                                                        "
                                                        >送餐</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            1
                                                        "
                                                        >堂食</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            2
                                                        "
                                                        >自取</span
                                                    >
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="payStatus"
                                                label="支付状态"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row
                                                                .payStatus == 0
                                                        "
                                                        style="color: #ff0000"
                                                        >已支付</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row
                                                                .payStatus == 1
                                                        "
                                                        style="color: #0d7000"
                                                        >已支付</span
                                                    >
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="istake"
                                                label="取餐状态"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row.istake ==
                                                            0
                                                        "
                                                        style="color: #1560eb"
                                                        >未取餐</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row.istake ==
                                                            1
                                                        "
                                                        >已取餐</span
                                                    >
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="orderTimeStr"
                                                label="订餐时间"
                                                align="center"
                                            >
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-card>
                            </el-col>
                            <el-col :span="8">
                                <el-card class="box-card lunchreserve">
                                    <div slot="header" class="clearfix">
                                        <span class="clearfix">
                                            <a class="imgbox">
                                                <img
                                                    src="@/assets/foodicon/a2.png"
                                                    alt=""
                                                />
                                            </a>
                                            今日预定</span
                                        >
                                    </div>
                                    <div class="text item lutable">
                                        <el-table
                                            :data="lunchlist"
                                            style="
                                                width: 100%;
                                                background-color: #ecf9fe;
                                            "
                                            height="37vh"
                                        >
                                            <el-table-column
                                                type="index"
                                                label="序号"
                                                width="50"
                                                align="center"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                prop="customerName"
                                                label="姓名"
                                                width="70"
                                                align="center"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                prop="takeWay"
                                                label="取餐方式"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            0
                                                        "
                                                        >送餐</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            1
                                                        "
                                                        >堂食</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            2
                                                        "
                                                        >自取</span
                                                    >
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="payStatus"
                                                label="支付状态"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row
                                                                .payStatus == 0
                                                        "
                                                        style="color: #ff0000"
                                                        >已支付</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row
                                                                .payStatus == 1
                                                        "
                                                        style="color: #0d7000"
                                                        >已支付</span
                                                    >
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="istake"
                                                label="取餐状态"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row.istake ==
                                                            0
                                                        "
                                                        style="color: #1560eb"
                                                        >未取餐</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row.istake ==
                                                            1
                                                        "
                                                        >已取餐</span
                                                    >
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="orderTimeStr"
                                                label="订餐时间"
                                                align="center"
                                            >
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-card>
                            </el-col>
                            <el-col :span="8">
                                <el-card class="box-card dinnerreserve">
                                    <div slot="header" class="clearfix">
                                        <span class="clearfix">
                                            <a class="imgbox">
                                                <img
                                                    src="@/assets/foodicon/a3.png"
                                                    alt=""
                                                />
                                            </a>
                                            今日预定</span
                                        >
                                    </div>
                                    <div class="text item ditable">
                                        <el-table
                                            :data="dinnerlist"
                                            style="
                                                width: 100%;
                                                background-color: #f1f2ff;
                                            "
                                            height="37vh"
                                        >
                                            <el-table-column
                                                type="index"
                                                label="序号"
                                                width="50"
                                                align="center"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                prop="customerName"
                                                label="姓名"
                                                width="70"
                                                align="center"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                prop="takeWay"
                                                label="取餐方式"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            0
                                                        "
                                                        >送餐</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            1
                                                        "
                                                        >堂食</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            2
                                                        "
                                                        >自取</span
                                                    >
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="payStatus"
                                                label="支付状态"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row
                                                                .payStatus == 0
                                                        "
                                                        style="color: #ff0000"
                                                        >已支付</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row
                                                                .payStatus == 1
                                                        "
                                                        style="color: #0d7000"
                                                        >已支付</span
                                                    >
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="istake"
                                                label="取餐状态"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row.istake ==
                                                            0
                                                        "
                                                        style="color: #1560eb"
                                                        >未取餐</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row.istake ==
                                                            1
                                                        "
                                                        >已取餐</span
                                                    >
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="orderTimeStr"
                                                label="订餐时间"
                                                align="center"
                                            >
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-top: 20px">
                            <el-col :span="8">
                                <el-card class="box-card menureserve">
                                    <div slot="header" class="clearfix">
                                        <span>
                                            <a class="imgbox">
                                                <img
                                                    src="@/assets/foodicon/a4.png"
                                                    alt=""
                                                />
                                            </a>
                                            今日菜单</span
                                        >
                                    </div>
                                    <div class="text item metable">
                                        <el-table
                                            :data="menulist"
                                            style="
                                                width: 100%;
                                                background-color: #fefcef;
                                            "
                                            height="37vh"
                                        >
                                            <el-table-column
                                                prop="meal"
                                                label="养老院"
                                                align="center"
                                                width="110"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row.meal == 1
                                                        "
                                                        style="color: #ff0000"
                                                    >
                                                        <a class="imgbox">
                                                            <img
                                                                src="@/assets/foodicon/a1.png"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </span>
                                                    <span
                                                        v-if="
                                                            scope.row.meal == 2
                                                        "
                                                        style="color: #0d7000"
                                                    >
                                                        <a class="imgbox">
                                                            <img
                                                                src="@/assets/foodicon/a2.png"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </span>
                                                    <span
                                                        v-if="
                                                            scope.row.meal == 3
                                                        "
                                                        style="color: #0d7000"
                                                    >
                                                        <a class="imgbox">
                                                            <img
                                                                src="@/assets/foodicon/a3.png"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="foodName"
                                                label="菜品信息"
                                                align="center"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                label="用餐时间"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <span
                                                        v-if="
                                                            scope.row.meal == 1
                                                        "
                                                    >
                                                        {{
                                                            scope.row.breakfastStartTime.substring(
                                                                11,
                                                                16
                                                            )
                                                        }}-{{
                                                            scope.row.breakfastEndTime.substring(
                                                                11,
                                                                16
                                                            )
                                                        }}
                                                        <!-- {{ scope.row.breakfastStartTime | formatDate1 }}-{{
                              scope.row.breakfastEndTime | formatDate1
                            }} -->
                                                    </span>
                                                    <span
                                                        v-if="
                                                            scope.row.meal == 2
                                                        "
                                                    >
                                                        {{
                                                            scope.row.lunchStartTime.substring(
                                                                11,
                                                                16
                                                            )
                                                        }}-{{
                                                            scope.row.lunchEndTime.substring(
                                                                11,
                                                                16
                                                            )
                                                        }}
                                                        <!-- {{ scope.row.lunchStartTime | formatDate1 }}-{{
                              scope.row.lunchEndTime | formatDate1
                            }} -->
                                                    </span>
                                                    <span
                                                        v-if="
                                                            scope.row.meal == 3
                                                        "
                                                    >
                                                        {{
                                                            scope.row.dinnerStartTime.substring(
                                                                11,
                                                                16
                                                            )
                                                        }}-{{
                                                            scope.row.dinnerEndTime.substring(
                                                                11,
                                                                16
                                                            )
                                                        }}
                                                        <!--{{ scope.row.dinnerStartTime | formatDate1 }}-{{
                              scope.row.dinnerEndTime | formatDate1
                            }} -->
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-card>
                            </el-col>
                            <el-col :span="8">
                                <el-card class="box-card statusreserve">
                                    <div slot="header" class="clearfix">
                                        <span>
                                            <a class="imgbox">
                                                <img
                                                    src="@/assets/foodicon/a5.png"
                                                    alt=""
                                                /> </a
                                            >就餐实时状况</span
                                        >
                                    </div>
                                    <div class="text item sttable">
                                        <el-table
                                            :data="statuslist"
                                            style="width: 100%"
                                            height="37vh"
                                        >
                                            <el-table-column
                                                type="index"
                                                label="序号"
                                                width="50"
                                                align="center"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                prop="userName"
                                                label="姓名"
                                                width="70"
                                                align="center"
                                            >
                                            </el-table-column>
                                            <el-table-column
                                                prop="takeWay"
                                                label="取餐方式"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <!-- <span v-if='scope.row.takeWay == 0'>送餐</span>
                          <span v-if='scope.row.takeWay == 1'>堂食</span>
                          <span v-if='scope.row.takeWay == 2'>自取</span> -->
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            1
                                                        "
                                                        >线上</span
                                                    >
                                                    <span
                                                        v-if="
                                                            scope.row.takeWay ==
                                                            2
                                                        "
                                                        >线下</span
                                                    >
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="operation"
                                                label="支付方式"
                                                align="center"
                                            >
                                                <!-- <template slot-scope='scope'>
                          <span v-if='scope.row.payType == 1'>人脸识别</span>
                          <span v-if='scope.row.payType == 2'>支付宝</span>
                          <span v-if='scope.row.payType == 3'>微信</span>
                          <span v-if='scope.row.payType == 4'>现金</span>
                        </template> -->
                                            </el-table-column>
                                            <!-- <el-table-column prop="isRepast" label="状态" align="center">
                        <template slot-scope="scope">
                          <span v-if="scope.row.isRepast == 1" style="color: #ff0000"
                            >未送餐</span
                          >
                          <span v-if="scope.row.isRepast == 2" style="color: #2b6bec"
                            >送餐中</span
                          >
                          <span v-if="scope.row.isRepast == 3" style="color: #408540"
                            >已完成</span
                          >
                        </template>
                      </el-table-column> -->
                                            <el-table-column
                                                prop="operation"
                                                label="操作"
                                                align="center"
                                            >
                                                <template slot-scope="scope">
                                                    <el-tooltip
                                                        class="item"
                                                        effect="dark"
                                                        content="查看"
                                                        placement="top-start"
                                                    >
                                                        <button
                                                            style="
                                                                backgroundcolor: #fff;
                                                                border: none;
                                                            "
                                                            class="
                                                                iconfont
                                                                tabBtn
                                                            "
                                                            @click="
                                                                showDialog(
                                                                    '查看',
                                                                    scope.row
                                                                )
                                                            "
                                                        >
                                                            <i>
                                                                <img
                                                                    src="@/assets/foodicon/a7.png"
                                                                    alt=""
                                                                />
                                                            </i>
                                                        </button>
                                                    </el-tooltip>
                                                    <el-tooltip
                                                        class="item"
                                                        effect="dark"
                                                        content="提醒"
                                                        placement="top-start"
                                                        v-if="
                                                            scope.row
                                                                .isRepast == 1
                                                        "
                                                    >
                                                        <button
                                                            style="
                                                                backgroundcolor: #fff;
                                                                border: none;
                                                            "
                                                            @click="
                                                                showDialog(
                                                                    '提醒',
                                                                    scope.row
                                                                )
                                                            "
                                                        >
                                                            <i
                                                                ><img
                                                                    src="@/assets/foodicon/a8.png"
                                                                    alt=""
                                                            /></i>
                                                        </button>
                                                    </el-tooltip>
                                                    <el-tooltip
                                                        class="item"
                                                        effect="dark"
                                                        content="指派"
                                                        placement="top-start"
                                                        v-if="
                                                            scope.row
                                                                .isRepast == 1
                                                        "
                                                    >
                                                        <button
                                                            style="
                                                                backgroundcolor: #fff;
                                                                border: none;
                                                            "
                                                            class="
                                                                iconfont
                                                                tabBtn
                                                            "
                                                            @click="
                                                                showDialog(
                                                                    '指派',
                                                                    scope.row
                                                                )
                                                            "
                                                        >
                                                            <i>
                                                                <img
                                                                    src="@/assets/foodicon/a9.png"
                                                                    alt=""
                                                                />
                                                            </i>
                                                        </button>
                                                    </el-tooltip>
                                                    <el-tooltip
                                                        class="item"
                                                        effect="dark"
                                                        content="已送达"
                                                        placement="top-start"
                                                        v-if="
                                                            scope.row
                                                                .isRepast == 2
                                                        "
                                                    >
                                                        <button
                                                            style="
                                                                backgroundcolor: #fff;
                                                                border: none;
                                                            "
                                                            class="
                                                                iconfont
                                                                el-icon-circle-check
                                                                tabBtn
                                                            "
                                                            @click="
                                                                showDialog(
                                                                    '已送达',
                                                                    scope.row
                                                                )
                                                            "
                                                        ></button>
                                                    </el-tooltip>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </el-card>
                            </el-col>
                            <el-col :span="8">
                                <el-card class="box-card takeTypereserve">
                                    <div slot="header" class="clearfix">
                                        <span>
                                            <a class="imgbox">
                                                <img
                                                    src="@/assets/foodicon/a6.png"
                                                    alt=""
                                                /> </a
                                            >取餐方式统计</span
                                        >
                                    </div>
                                    <div class="text item takeType">
                                        <div
                                            id="echarts"
                                            ref="echarts"
                                            style="width: 100%; height: 100%"
                                        ></div>
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>

                <!-- 弹出对话框 -->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="visVisible"
                    class="addform"
                    width="700px"
                    :before-close="handleClose"
                >
                    <el-form
                        ref="addform"
                        :model="addform"
                        label-width="90px"
                        size="mini"
                    >
                        <el-form-item
                            label="姓名："
                            prop="customerName"
                            v-if="dialogTitle != '提醒'"
                        >
                            <el-input
                                :disabled="dialogTitle == '查看'"
                                v-model="addform.userName"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="餐饮类型："
                            prop="mealType"
                            v-if="dialogTitle != '提醒'"
                        >
                            <el-select
                                :disabled="dialogTitle == '查看'"
                                style="width: 100%"
                                v-model="addform.mealType"
                                placeholder="请选择"
                            >
                                <!-- <el-option
                v-for="item in dishesTasteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option> -->
                                <el-option label="早餐" value="0"></el-option>
                                <el-option label="午餐" value="1"></el-option>
                                <el-option label="晚餐" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="取餐方式："
                            v-if="dialogTitle != '提醒'"
                        >
                            <el-select
                                :disabled="dialogTitle == '查看'"
                                style="width: 100%"
                                v-model="addform.takeWay"
                                placeholder="请选择"
                            >
                                <!-- <el-option
                v-for="item in dishesTasteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option> -->
                                <!-- <el-option label='送餐' value='0'></el-option>
                <el-option label='堂食' value='1'></el-option>
                <el-option label='自取' value='2'></el-option> -->
                                <el-option label="线上" value="1"></el-option>
                                <el-option label="线下" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用餐时间：">
                            <el-date-picker
                                v-model="addform.create_time"
                                type="datetime"
                                style="width: 100%"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间"
                                align="right"
                                :disabled="dialogTitle == '查看'"
                            >
                                <!-- :picker-options="pickerOptions" -->
                            </el-date-picker>
                        </el-form-item>
                        <template v-if="addform.takeWay == 0">
                            <el-form-item
                                label="送餐人员："
                                prop="personName"
                                v-if="dialogTitle != '提醒'"
                            >
                                <el-select
                                    :disabled="dialogTitle == '查看'"
                                    style="width: 100%"
                                    v-model="addform.personName"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="item in delivery"
                                        :key="item.id"
                                        :label="item.personName"
                                        :value="item.id"
                                    >
                                    </el-option>
                                    <!-- <el-option label="送餐员1" value="1"></el-option> -->
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="状态："
                                prop="isRepast"
                                v-if="dialogTitle != '提醒'"
                            >
                                <el-select
                                    :disabled="dialogTitle == '查看'"
                                    style="width: 100%"
                                    v-model="addform.isRepast"
                                    placeholder="请选择"
                                >
                                    <!-- <el-option
                  v-for="item in dishesTasteOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option> -->
                                    <el-option
                                        label="未送餐"
                                        value="0"
                                    ></el-option>
                                    <el-option
                                        label="送餐中"
                                        value="2"
                                    ></el-option>
                                    <el-option
                                        label="已完成"
                                        value="1"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <p
                                v-if="dialogTitle == '提醒'"
                                style="text-align: center; font-size: 20px"
                            >
                                是否通知送餐人员马上送餐
                            </p>
                        </template>
                    </el-form>
                    <div slot="footer" v-if="dialogTitle != '查看'">
                        <el-button type="primary" @click="save">确定</el-button>
                        <el-button @click="cancel('addForm')">取消</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import { post } from "../../api/requrestHttp"
import provideManageVue from "../../views/platform/provideManage.vue"

export default {
    data() {
        return {
            nowDate: "",
            dialogImageUrl: "",
            dialogVisible1: false,
            // 导航栏
            editableTabsValue: "1",
            // 早餐
            breakfastlist: [],
            // 午餐
            lunchlist: [],
            // 晚餐
            dinnerlist: [],
            photo: [],
            // 三餐
            menulist: [],
            echartsdate: [
                {
                    value: "",
                    name: "",
                },
            ],
            echartsname: [],
            // 就餐情况
            statuslist: [],
            // 弹框
            visVisible: false,
            dialogTitle: "",
            addform: {
                name: "",
                materialPhoto: "",
                cateringType: "",
                takeType: "",
                deliveryPersonnel: "",
                state: "",
                photo: "",
                customerName: "",
            },
            pageNo: 1,
            pageSize: 10,
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            delivery: [],
        }
    },
    updated() {
        console.log(this.breakfastlist)
        console.log(this.lunchlist)
        console.log(this.dinnerlist)
    },
    filters: {
        //时间格式化
        formatDate1(date) {
            let dt = new Date(date)
            let dty = dt.getFullYear()
            let dtm = (dt.getMonth() + 1).toString().padStart(2, "0")
            let dtd = dt.getDate().toString().padStart(2, "0")
            let dth = dt.getHours().toString().padStart(2, "0")
            let dtmi = dt.getMinutes().toString().padStart(2, "0")
            let dts = dt.getSeconds().toString().padStart(2, "0")
            return dth + ":" + dtmi
        },
    },
    methods: {
        dataTime() {
            //获取当前时间
            var date = new Date()
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()
            if (month < 10) {
                month = "0" + month
            }
            if (day < 10) {
                day = "0" + day
            }
            this.nowDate = year + "-" + month + "-" + day
            this.showList5()
        },
        // 预览图片
        handlePicturePreview(file) {
            this.dialogVisible1 = true
            this.dialogImageUrl = file.url
        },

        drawLine(echartsname = [], echartsdate = []) {
            let chart = this.$echarts.init(this.$refs.echarts)
            // 编写echart参数
            let option = {
                backgroundColor: "#FDF3FE",
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)",
                },
                legend: {
                    bottom: 10,
                    left: "center",
                    // data:echartsname
                },
                series: [
                    {
                        name: "取餐方式",
                        type: "pie",
                        radius: ["40%", "60%"],
                        center: ["50%", "40%"],
                        data: echartsdate,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            }
            // 设置图表的参数
            chart.setOption(option)
            setTimeout(function () {
                window.onresize = function () {
                    chart.resize()
                }
            }, 200)
        },
        showDialog(type, date) {
            console.log(date)
            this.visVisible = true
            this.dialogTitle = type
            switch (type) {
                case "查看":
                    // this.addform.userName = date.userName
                    // this.addform.takeWay = date.takeWay
                    // this.addform.operation = date.operation
                    break
                case "编辑":
                    break
                case "指派":
                    this.look(date)
                    break
            }
            post("/sqyl/consumeRecord/info/get", {
                id: date.id,
            }).then((res) => {
                console.log(res.content)
                this.addform = res.content
            })
        },
        // 表单重置
        resert() {
            this.$refs.addform.resetFields()
        },
        // 保存
        submitForm() {
            this.resert()
            this.visVisible = false
        },
        // 取消
        cancel() {
            this.resert()
            this.visVisible = false
        },
        handleClose() {
            this.resert()
            this.visVisible = false
        },

        //时间格式化
        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property]
            if (data == null) {
                return null
            }
            let dt = new Date(data)
            let dty = dt.getFullYear()
            let dtm = (dt.getMonth() + 1).toString().padStart(2, "0")
            let dtd = dt.getDate().toString().padStart(2, "0")
            let dth = dt.getHours().toString().padStart(2, "0")
            let dtmi = dt.getMinutes().toString().padStart(2, "0")
            let dts = dt.getSeconds().toString().padStart(2, "0")
            return dty + "-" + dtm + "-" + dtd + " " + dth + ":" + dtmi
        },

        // 接口
        showList1() {
            // 早餐
            post("/sqyl/admin/order/findOrderByToday", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                orderType: "1",
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }).then((res) => {
                console.log(res)
                this.breakfastlist = res.content
            })
        },
        showList2() {
            // 午餐
            post("/sqyl/admin/order/findOrderByToday", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                orderType: "2",
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }).then((res) => {
                // console.log(res);
                this.lunchlist = res.content
            })
        },

        showList3() {
            // 晚餐
            post("/sqyl/admin/order/findOrderByToday", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                orderType: "3",
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }).then((res) => {
                // console.log(res);
                this.dinnerlist = res.content
            })
        },
        // echarts
        showList4() {
            let self = this
            post("/sqyl/admin/pay/takeWayCount1", {
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }).then((res) => {
                self.echartsname = ["线上", "线下"]
                self.echartsdate = [
                    {
                        value: res.content.line,
                        name: "线上",
                    },
                    {
                        value: res.content.underline,
                        name: "线下",
                    },
                ]
                // console.log(res)
                // self.echartsname = res.content.reduce((prve, item) => {
                //   if (item.takeWay === '0') {
                //     item.takeWay = '送餐'
                //   }
                //   if (item.takeWay === '1') {
                //     item.takeWay = '食堂'
                //   }
                //   if (item.takeWay === '2') {
                //     item.takeWay = '自取'
                //   }
                //   prve.push(item.takeWay)
                //   return prve
                // }, [])
                // self.echartsname = res.content.map((item) => {
                //   if(item.takeWay === '0'){
                //     item.takeWay = '送餐'
                //   } if(item.takeWay === '1'){
                //     item.takeWay = '食堂'
                //   } if(item.takeWay === '2'){
                //     item.takeWay = '自取'
                //   }
                //   return {
                //     prve: item.takeWay,
                //   };
                // });
                // self.echartsdate = res.content.map((item) => {
                //   if (item.takeWay === '0') {
                //     item.takeWay = '送餐'
                //   }
                //   if (item.takeWay === '1') {
                //     item.takeWay = '食堂'
                //   }
                //   if (item.takeWay === '2') {
                //     item.takeWay = '自取'
                //   }
                //   return {
                //     value: item.count,
                //     name: item.takeWay
                //   }
                // })
                // console.log(self.echartsname, 888)
                // console.log(self.echartsdate, 7778)
                this.drawLine(self.echartsname, self.echartsdate)
            })
        },

        // 就餐
        showList5() {
            post("/sqyl/consumeRecord/info/findList", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                startTime: this.nowDate,
                endTime: this.nowDate,
            }).then((res) => {
                console.log(res.content.list)
                this.statuslist = res.content.list
            })
        },
        // 就餐查看
        look(date) {
            post("/sqyl/admin/pay/index", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                id: date.id,
            }).then((res) => {
                console.log(res.content)
                // console.log(res);
                // console.log(res.content.personId);
                if (res.content != null) {
                    if (res.content.list.length == 0) return
                    let [data = {}] = res.content.list
                    // this.addform = data
                    this.addform.customerName = data.customerName
                    this.addform.orderType = data.orderType
                    console.log(this.addform, "list=>>>>")
                    //   name: "",
                    // materialPhoto: "",
                    // cateringType: "",
                    // takeType: "",
                    // deliveryPersonnel: "",
                    // state: "",
                    // photo: "",
                    // customerName:""
                }
            })
        },
        // 就餐菜单
        look1(date) {
            post("/sqyl/admin/menus/info/findList", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                id: date.id,
            }).then((res) => {
                // console.log(res);
                this.addform = res.content
            })
        },
        // 送餐人
        look2() {
            post("/sqyl/admin/pay/findPerson", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }).then((res) => {
                // console.log(res);
                this.delivery = res.content
            })
        },
        // 指派
        save() {
            console.log(this.addform)
            let params = {
                personId: this.addform.personId,
                customerId: this.addform.customerId,
                id: this.addform.id,
            }
            post("/sqyl/admin/pay/appoint", params).then((res) => {
                // console.log(res);
                if (res.code == 200) {
                    this.visVisible = false
                }
            })
        },

        showToday() {
            // 今日菜单
            // post("/sqyl/admin/weeklyMenu/findTodayFoodList").then((res) => {
            //   console.log(res);
            //   this.menulist = res.content;

            // });
            let params = {
                // personId: this.addform.personId,
                // customerId: this.addform.customerId,
                // id: this.addform.id,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            post("/sqyl/admin/weeklyMenu/findTodayFoodList", params).then(
                (res) => {
                    // console.log(res);
                    if (res.code == 200) {
                        this.menulist = res.content
                        console.log(this.menulist, 999)
                    }
                }
            )
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.showList1()
            this.showList2()
            this.showList3()
            this.showList4()
            this.look2()
            this.showToday()
            this.dataTime()
        })
    },
}
</script>
<style lang='less' scoped>
.rkld {
    display: flex;
    flex-direction: row;
    height: 100vh;
    overflow: hidden;
}

.rkldLeft {
    width: 234px;
    height: 100%;
    background: #37404f;
}

.rkldLeftLogo {
    background-color: rgb(55, 64, 79);
    height: 68px;
    width: 100%;
    display: flex;
    align-items: center;
    color: #ffffff;
}

.rkldRight {
    flex: 1;
    height: 100%;
    width: calc(100% - 254px);
    background-color: #ffffff;
}

.rkldRightHead {
    border-bottom: 1px solid #f5f5f5;
    width: 100%;
    background-color: #ececec;
    height: 69px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.mlIcon {
    height: 35px;
    width: 35px;
    font-size: 14px;
    margin-left: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 3px;
}

.mlIcon:hover {
    background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar {
    display: none !important;
}

.rkldRightHeadRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 15px;
}

.demo-form-inline {
    padding: 0 5%;
}

.btnform {
    text-align: center;
}

.bodymsg {
    width: 140px;
    height: 40px;
    background-color: #ffb404;
    color: #fff;
    text-align: center;
    line-height: 40px;
    border-radius: 2px;
    margin-top: 20px;
    cursor: pointer;
}

.switchpage {
    display: inline-block;
    margin-bottom: 10px;
}

.activesiwtch {
    background-color: #d6d7d8;
}

.rkldRightHeadRightLeft {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 12px;
}

.rkldRightHeadRightLeft img {
    margin-right: 5px;
}

.rkldRightContent {
    height: calc(100% - 70px);
    overflow-y: auto;
    margin: 20px;
}

/deep/ .el-tabs__content {
    padding-bottom: 20px;
}

.el-submenu /deep/ .el-menu-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/deep/ .el-submenu__title {
    border-bottom: 1px solid #2c3342;
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-menu-item {
    border-bottom: 1px solid #2c3342;
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
    border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
    .el-tabs--card
    > .el-tabs__header
    /deep/
    .el-tabs__item.is-active.is-closable {
    color: #0e2d5f;
}

/deep/ .el-menu .is-active {
    color: rgb(255, 255, 255) !important;
    background-color: #437ae1 !important;
}

/deep/ .el-submenu {
    width: 234px !important;
}

/deep/ .el-menu-item:hover {
    color: rgb(255, 255, 255) !important;
    background-color: #437ae1 !important;
}

.rkld .el-menu-vertical-demo:not {
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-card__body {
    overflow-y: hidden;
    height: 37vh;
}

// 弹框底部
/deep/ .addform .el-dialog__footer {
    background-color: #f5f5f5;
}

/deep/ .item {
    height: 100%;
    overflow-y: scroll;
}

.el-card__header span {
    padding: 3px 0;
}

.imgbox {
    display: inline-block;
    width: 20px;
    height: 20px;
}

.imgbox > img {
    width: 100%;
}

// 早餐
/deep/ .breakfastreserve .el-card__header {
    border-bottom: 2px solid #40efc2;
}

/deep/ .breakfastreserve .el-card__body {
    background-color: #eefefa;
}

.bktable {
    /deep/ .el-table__empty-block {
        background-color: #eefefa;
    }

    /deep/ .el-table th {
        background-color: #eefefa;
    }

    /deep/ .el-table::before {
        //去除底部白线
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
    }

    /deep/ .el-table tr {
        background-color: #eefefa;
    }
}

// 午餐
/deep/ .lunchreserve .el-card__header {
    border-bottom: 2px solid #26b7f3;
}

/deep/ .lunchreserve .el-card__body {
    background-color: #ecf9fe;
}

.lutable {
    /deep/ .el-table__empty-block {
        background-color: #ecf9fe;
    }

    /deep/ .el-table th {
        background-color: #ecf9fe;
    }

    /deep/ .el-table::before {
        //去除底部白线
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
    }

    /deep/ .el-table tr {
        background-color: #ecf9fe;
    }
}

// 晚餐
/deep/ .dinnerreserve .el-card__header {
    border-bottom: 2px solid #656cff;
}

/deep/ .dinnerreserve .el-card__body {
    background-color: #f1f2ff;
}

.ditable {
    /deep/ .el-table__empty-block {
        background-color: #f1f2ff;
    }

    /deep/ .el-table th {
        background-color: #f1f2ff;
    }

    /deep/ .el-table::before {
        //去除底部白线
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
    }

    /deep/ .el-table tr {
        background-color: #f1f2ff;
    }
}

// 菜单
/deep/ .menureserve .el-card__header {
    border-bottom: 2px solid #efcf1d;
}

/deep/ .menureserve .el-card__body {
    background-color: #fefcef;
}

.metable {
    /deep/ .el-table__empty-block {
        background-color: #fefcef;
    }

    /deep/ .el-table th {
        background-color: #fefcef;
    }

    /deep/ .el-table::before {
        //去除底部白线
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
    }

    /deep/ .el-table tr {
        background-color: #fefcef;
    }
}

// 就餐
/deep/ .statusreserve .el-card__header {
    border-bottom: 2px solid #fdb6aa;
}

/deep/ .statusreserve .el-card__body {
    background-color: #fff6f5;
}

.sttable {
    /deep/ .el-table__empty-block {
        background-color: #fff6f5;
    }

    /deep/ .el-table th {
        background-color: #fff6f5;
    }

    /deep/ .el-table::before {
        //去除底部白线
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0px;
    }

    /deep/ .el-table tr {
        background-color: #fff6f5;
    }
}

// 取餐方式
/deep/ .takeTypereserve .el-card__header {
    border-bottom: 2px solid #ea74f4;
}

/deep/ .takeTypereserve .el-card__body {
    background-color: #fdf3fe;
    overflow: hidden;
}

// 弹框
/deep/ .addform .el-card__header {
    border-bottom: 2px solid #707070;
}
</style>
